import { useMemo, useState } from "react";
import { useWorkOrderDetail } from "../../../../entities/work-order";
import { mapWorkOrderToImmotionAuftragFields } from "./mapWorkOrderToImmotionAuftragFields";

export const useImmotionAuftrag = (immotionAuftragId: string) => {
  const [requestedAuftragId, setRequestedAuftragId] = useState("");

  const {
    data: workOrder,
    isFetching,
    error,
  } = useWorkOrderDetail(requestedAuftragId);

  const immotionFields = useMemo(
    () => mapWorkOrderToImmotionAuftragFields(workOrder),
    [workOrder],
  );

  const handleLoadAuftrag = () => {
    const id = immotionAuftragId.trim();
    if (!id) {
      return;
    }

    setRequestedAuftragId(id);
  };

  return {
    immotionFields,
    workOrder,
    isFetching,
    error,
    handleLoadAuftrag,
  };
};
